/**
 * IMPORTS
 */

// repositories
import { SincronizarCamposVariaveisModeloRepositoryImplementation } from "@/data/infra/repositories/modelos/sincronizar-campos-variaveis-modelo-repository-impl";
// use cases
import { SincronizarCamposVariaveisModeloUseCase } from "@/domain/use-cases/modelos/sincronizar-campos-variaveis-modelo-use-case";

function makeSincronizarCamposVariaveisModeloUseCase() {
  const repository = new SincronizarCamposVariaveisModeloRepositoryImplementation();
  return new SincronizarCamposVariaveisModeloUseCase(repository);
}

/**
 * EXPORT
 */
export { makeSincronizarCamposVariaveisModeloUseCase };
